<template>
    <div id="new-openai-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            :placeholder="$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>

                <div class="input-wrapper">
                    <label>API Anahtarı Modu</label>
                    <div class="key-mode-selector">
                        <div
                            class="key-mode-option"
                            :class="{ active: form.keyMode === 'byok' }"
                            @click="form.keyMode = 'byok'"
                        >
                            <a-radio :checked="form.keyMode === 'byok'" />
                            <div class="key-mode-content">
                                <div class="key-mode-title">Kendi API Anahtarımı Kullanacağım (BYOK)</div>
                                <div class="key-mode-desc">OpenRouter hesabınızdaki API anahtarınızı kullanın</div>
                            </div>
                        </div>
                        <div
                            class="key-mode-option"
                            :class="{ active: form.keyMode === 'supsis' }"
                            @click="form.keyMode = 'supsis'"
                        >
                            <a-radio :checked="form.keyMode === 'supsis'" />
                            <div class="key-mode-content">
                                <div class="key-mode-title">Supsis AI API Anahtarı Sağlasın</div>
                                <div class="key-mode-desc">Supsis tarafından sağlanan API anahtarı ile kullanın</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input-wrapper" v-if="form.keyMode === 'byok'">
                    <label>OpenAI API KEY</label>
                    <a-input placeholder="OpenAI API KEY" v-model="form.apiKey" name="apiKey" />
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("message.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.save") }}</a-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "NewOpenAIChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
        update: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data() {
        return {
            form: {
                channelName: this.$_.get(this.channel, "name", ""),
                apiKey: this.$_.get(this.channel, "payload.apiKey", ""),
                keyMode: this.$_.get(this.channel, "payload.keyMode", "byok"),
                settings: {
                    useAIAssistant: this.$_.get(this.channel, "payload.settings.useAIAssistant", false),
                },
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({}),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            updateChannel: "channel/updateChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        buildPayload() {
            var channelPayload = {
                keyMode: this.form.keyMode,
                settings: {
                    useAIAssistant: this.form.settings.useAIAssistant,
                },
            };
            if (this.form.keyMode === "byok") {
                channelPayload.apiKey = this.form.apiKey;
            }
            return channelPayload;
        },
        handleSave() {
            if (this.update) {
                this.loading = true;
                this.updateChannel({
                    ...this.channel,
                    type: "openai",
                    name: this.form.channelName,
                    payload: this.buildPayload(),
                })
                    .then(() => {
                        this.$message.success("Channel updated successfully");
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                return;
            }
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    const payload = {
                        type: "openai",
                        name: this.form.channelName,
                        payload: this.buildPayload(),
                    };
                    this.loading = true;
                    this.createChannel(payload)
                        .then(() => {
                            this.$message.success(this.$t("message.channelCreatedSuccessfully"));
                            this.$emit("ok");
                        })
                        .catch((err) => {
                            this.$message.error(this.$t("message.failedToCreateChannel"));
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        },
    },
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#new-openai-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;

            &.ai-assistant {
                width: fit-content;

                .ai-assistant {
                    font-size: 14px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }
            }
        }
    }

    .key-mode-selector {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .key-mode-option {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            padding: 14px;
            border: 2px solid var(--color-border-default);
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s ease;

            &:hover {
                border-color: var(--color-primary-light, #a0c4ff);
            }

            &.active {
                border-color: var(--color-primary, #1890ff);
                background: var(--color-bg-light, #f0f7ff);
            }

            .key-mode-content {
                .key-mode-title {
                    font-size: 14px;
                    font-weight: 600;
                    color: var(--color-text-default);
                }

                .key-mode-desc {
                    font-size: 12px;
                    color: var(--color-text-secondary, #999);
                    margin-top: 2px;
                }
            }
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-sms-postacell {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
